module.exports = __webpack_public_path__ + "img/nature-20.1719edec.jpg";